import { getLocationPathname } from 'core/utilities';
import { useLocation, useParams } from 'react-router';

import type { Catalog } from 'core/domains';

export function useLocationQueryOptions() {
  const { state } = useLocation();
  const query = useParams<{ category: string; q: string }>();
  const pathname = getLocationPathname();

  const departmentFromUrl = pathname.split('/').length >= 2 ? pathname.split('/')[2] : '';
  const categoryFromUrl = new URLSearchParams(window.location.search).get('category');
  const geraCategoryFromUrl = new URLSearchParams(window.location.search).get('geraCategory');

  const department = departmentFromUrl || state?.pathQueryTitle || '';
  const geraCategory = geraCategoryFromUrl;

  return {
    ...(geraCategory ? { geraCategory } : { department }),
    category: categoryFromUrl || query.category || '',
    query: decodeURIComponent(query.q || ''),
  } as Catalog['queryOptions'];
}
